import GestionAvis from "./GestionAvis";

// Un seul état et un seul formulaire : une bascule de largeur ne perd pas la saisie.
export default GestionAvis;
